// @flow
import { type Effect } from 'effector'

import * as Api from '../api'
import {
  compareFormSpyValues,
  getStorageValues,
  setStorageValues,
  transformFormSpyValues,
  transformUserInterests,
} from '../utils'
import type { FormSpyValues } from '../types'

import { SpyDomain } from './domain'

export const setSpyValues = SpyDomain.event<FormSpyValues>('set spy values')

export const removeSpyValue = SpyDomain.event<string>('remove spy value')

export const saveUserFormValues: Effect<FormSpyValues, FormSpyValues> = SpyDomain.effect(
  'save user specific form values',
  {
    handler(data) {
      setStorageValues(data)

      if (window.app_options?.user.id) {
        try {
          const userInterests = transformFormSpyValues(data)

          Api.updateUserInterests(userInterests)
        } catch (error) {
          // Keep user interests in local storage (in 'form-spy-manager' key)
        }
      }

      return data
    },
  }
)

export const loadSpyValues: Effect<void, FormSpyValues> = SpyDomain.effect('get user specific from storage', {
  async handler() {
    let values = getStorageValues()

    if (window.app_options?.user.id) {
      try {
        let interests = await Api.getUserInterests()

        interests = transformUserInterests(interests)
        values = { ...values, ...interests }

        if (!compareFormSpyValues(interests, values)) {
          saveUserFormValues(values)
        }
      } catch (error) {
        // Use values from local storage if they are exist
      }
    }

    return values === null ? {} : values
  },
})
